import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { RoadTypeFailure, RoadTypeRequest, RoadTypeSuccess } from './actions';
import { RoadTypeService } from './service';

@Injectable()
export class RoadTypeEffects {
  private readonly actions$ = inject(Actions);
  private readonly roadTypeService = inject(RoadTypeService);

  roadType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoadTypeRequest),
      switchMap(({ parameters }) =>
        this.roadTypeService.roadType(parameters).pipe(
          map(data => RoadTypeSuccess({ data })),
          catchError(error => of(RoadTypeFailure({ error })))
        )
      )
    )
  );

}
